<template>
  <section class="modules-wrap">
    <!-- table start -->
    <div class="table">
    

<el-collapse accordion v-if="is_print_member_no==1">

      <el-collapse-item v-for="(item, index) of tableData" :key="item[id]" class="table-row">
    <template slot="title">
      <!-- 头部 start -->
        <div class="table-row-header">
          <div class="header-content">
            <div class="content-left">
              {{ `${index + 1}# ${item.product_title}` }}
            </div>
            <div>
              <span class="label">总件数：</span
              >{{ item.product_number }}&nbsp;&nbsp;/&nbsp;
              <span class="label">等级：</span
              >{{ item.product_grade }}&nbsp;&nbsp;/&nbsp;
              <span class="label">规格：</span>{{ item.product_spec }}
            </div>
          </div>
        </div>
        <!-- 头部 end -->

        <!-- 右侧打印按钮 start -->
        <div class="print-btn" @click.stop="onHandlePrint(item)">打印标签</div>
        <!-- 右侧打印按钮 end -->
    </template>
    <el-table
    :data="item.order_detail_list"
 :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    style="width: 100%">
    <el-table-column
      prop="logistics_name"
      label="城市仓名称"
       align="center"
      >
    </el-table-column>
    <el-table-column
      prop="delivery_name"
      label="自提点名称"
       align="center"
      >
    </el-table-column>
    <el-table-column
      prop="vehicle_no"
      label="车位号"
       align="center"
      >
    </el-table-column>
    <el-table-column
      prop="sort_code"
      label="坑位号"
       align="center">
    </el-table-column>
    <el-table-column
      prop="member_name"
      label="客户名称"
       align="center">
    </el-table-column>
    <el-table-column
      prop="member_mobile"
      label="客户电话"
       align="center">
    </el-table-column>
    <el-table-column
      prop="qty"
      label="订货数量"
       align="center">
    </el-table-column>
    <el-table-column
      prop="no_print_num"
      label="未打印数量"
       align="center">
    </el-table-column>
    <el-table-column
      prop="address"
      label="功能"
       align="center">


       <template slot-scope="scope">
            <el-button
              type="text"
             
              @click="handleEdit(scope.row)"
              >打印标签</el-button
            >
            
          </template>
    </el-table-column>
  </el-table>
  </el-collapse-item>


</el-collapse>
<div v-else>
<div v-for="(item, index) of tableData" :key="item[id]" class="table-row" style="display: flex;">
 <div class="table-row-header">
          <div class="header-content">
            <div class="content-left">
              {{ `${index + 1}# ${item.product_title}` }}
            </div>
            <div>
              <span class="label">总件数：</span
              >{{ item.product_number }}&nbsp;&nbsp;/&nbsp;
              <span class="label">等级：</span
              >{{ item.product_grade }}&nbsp;&nbsp;/&nbsp;
              <span class="label">规格：</span>{{ item.product_spec }}
            </div>
          </div>
        </div>
        <!-- 头部 end -->

        <!-- 右侧打印按钮 start -->
        <div class="print-btn" @click.stop="onHandlePrint(item)">打印标签</div>
        <!-- 右侧打印按钮 end -->
</div>
</div>

    </div>
    <!-- table end -->
  </section>
</template>

<script>
export default {
  name: "TableList",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    is_print_member_no: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: "product_id",
    };
  },
  computed: {},
  methods: {
    handleEdit(data){
 this.$emit("handleEdit", data);
    },
    /**
     * 打印标签
     */
    onHandlePrint(data) {
      this.$emit("on-handle-print", data);
    },
  },
};
</script>

<style lang="scss" scoped>
$border: 1px solid $border-color;
.modules-wrap {
  .table {
     /deep/ .el-collapse-item__wrap{
      margin-top: 10px;
    }
    &-row {
      // display: flex;
      // align-content: center;
      // justify-content: center;
      // gap: 30px;
      // margin-bottom: 30px;
      margin: 10px 0;
      &-header {
        display: flex;
        flex: 1;
        height: 56px;
        padding: 0 0px;
        line-height: 56px;
        font-size: 20px;
        border: $border;
        color: $theme-color;
        background-color: #fbfdf9;
        .header-content {
          flex: 1;
          display: flex;
          gap: 50px;
          .content-left {
            min-width: 400px;
          }
          .label {
            color: $border-color;
          }
        }
      }
      .print-btn {
        position: relative;
        top: 6px;
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        border-radius: 4px;
        display: inline-block;
        font-size: 12px;
        color: #fff;
        background-color: #13AE67;
        cursor: pointer;
      }
    }
  }
}
</style>
